import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Typography, Button, Box, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, useTheme, useMediaQuery } from '@mui/material';
import { Link, Routes, Route } from 'react-router-dom';
import HeroSection from '../HeroSection/hero';
import AboutUs from '../AboutSection/about';
import Projects from '../Projects/projects';
import EducationAndWork from '../Work&Edu/EducationAndWork';
import ContactForm from '../ContactSection/contactForm';
import MyGallery from '../Certfications/certifications';
import AboutSection from '../AboutSection/about';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import WorkIcon from '@mui/icons-material/Work';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import Skills from '../Skills/skills';
import VerifiedIcon from '@mui/icons-material/Verified';
import CodeIcon from '@mui/icons-material/Code';
import TicTacToe from '../Games/tictactoe';

const Navbar = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const [drawerOpen, setDrawerOpen] = useState(false);

    const toggleDrawer = (open) => () => {
        setDrawerOpen(open);
    };

    const navItems = [
        { text: 'Home', icon: <HomeIcon /> },
        { text: 'Certifications', icon: <VerifiedIcon /> },
        { text: 'Contact', icon: <ContactMailIcon /> },
        { text: 'Education & Work', icon: <WorkIcon /> },
        { text: 'Projects', icon: <CodeIcon /> },
        { text: 'Skills', icon: <EmojiObjectsIcon /> },
    ];

    return (
        <>
            <AppBar position="static" style={{ background: 'transparent', boxShadow: 'none' }}>
                <Toolbar>
                    {(isMobile || isTablet) && (
                        <IconButton
                            size="large"
                            edge="start"
                            color="secondary"
                            style={{ color: '#f9004d' }}
                            aria-label="menu"
                            onClick={toggleDrawer(true)}
                        >
                            <MenuIcon />
                        </IconButton>
                    )}
                    <Typography variant="h6" sx={{ flexGrow: 1, color: 'black', fontWeight: 'bold', fontSize: isMobile ? '14px' : '24px' }}>
                        Anand<span style={{ color: '#f9004d' }}> Pandey</span>
                    </Typography>
                    {!isMobile && !isTablet && (
                        <Box sx={{ display: 'flex', flexGrow: 0.9, justifyContent: 'center' }}>
                            {navItems.map(({ text }) => (
                                <Button key={text} component={Link} to={'/' + text.replace(/ & /g, '').toLowerCase()}
                                    sx={{
                                        color: 'black',
                                        fontWeight: 'bold',
                                        fontSize: '18px',
                                        '&:hover': {
                                            color: '#f9004d',
                                            backgroundColor: 'transparent'
                                        }
                                    }}>
                                    {text}
                                </Button>
                            ))}
                        </Box>
                    )}
                    <Button sx={{
                        backgroundColor: '#f9004d',
                        borderRadius: '5px',
                        color: 'white',
                        fontWeight: '800',
                        fontSize: isMobile ? '10px' : '15px',
                        border: '2px solid transparent',
                        '&:hover': {
                            backgroundColor: 'transparent',
                            color: 'black',
                            border: '2px solid #f9004d'
                        }
                    }}
                        href="https://www.linkedin.com/in/anand-pandey-9a947520b/"
                        target="_blank"
                        rel="noopener noreferrer">
                        <LinkedInIcon style={{ marginRight: '8px' }} />
                        Connect On LinkedIn
                    </Button>
                </Toolbar>
            </AppBar>
            <Drawer
                anchor="left"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
            >
                <List>
                    {navItems.map(({ text, icon }) => (
                        <ListItem key={text} disablePadding>
                            <ListItemButton component={Link} to={'/' + text.replace(/ & /g, '').toLowerCase()} onClick={toggleDrawer(false)}>
                                <ListItemIcon>
                                    {icon}
                                </ListItemIcon>
                                <ListItemText primary={text} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Drawer>
            <Routes>
                <Route path="/" element={ <> <HeroSection /> <AboutSection/></>}/>
                <Route path="/home" element={ <> <HeroSection /> <AboutSection/></>} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/contact" element={<ContactForm />} />
                <Route path="/educationwork" element={<EducationAndWork />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/certifications" element={<MyGallery />} />
                <Route path="/skills" element={<Skills />} />
                <Route path="/tictactoe" element={<TicTacToe />} />
                
            </Routes>
        </>
    );
};

export default Navbar;
